import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Context } from '../../lib/Context';
import '../../lib/css/HomePage.css';
import { useTranslation } from '../../hooks/useTranslation';
import TriathlonPage from './PageElements/TriathlonPage';

const HomePage = () => {
    const { viewPage, setViewPage, email, setShowAuth } = useContext(Context);
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        if (location.pathname === '/events' && !email) {
            window.location.href = "http://localhost:3000"
        }
        if (location.pathname === '*') {
            setViewPage('home');
        }
    }, [location.pathname, setViewPage, email]);

    const eventType = ['Standard', 'Sprint']

    return (
        viewPage === 'home-page' &&
        <TriathlonPage viewPage={viewPage} t={t} setShowAuth={setShowAuth} eventType={eventType} />
    )
}

export default HomePage